import * as React from "react";
import {cx} from "emotion";
import {cs} from "@Common/react/chain-services";
import {faBuilding} from "@fortawesome/free-solid-svg-icons";

import {PAGE_VIEW}          from "../xpresslinks-landing";
import {messageSubmissionSuccessful, DURATION_NOTIFICATION} from "../common";
import {contactFormContent, contactFormStateValidator}      from "../contact-form";
import {bindInput}                                          from "@Common/react/bind-input";
import {consumeContext}                                     from "@Common/react/context";
import {scopedState}                                        from "@Common/react/scoped-state";
import {scnv}                                               from "@Common/react/state-change-nested-value";
import {UseState}                                           from "@Common/react/use-state";
import {BubbleNoti2}                                        from "@Common/ui-components/bubble-noti-2/bubble-noti-2";
import {Checkbox}                                           from "@Common/ui-components/heavy/common/design2/checkbox/checkbox";
import {equalDeep}                                          from "@Common/utils/objects";
import {faRightLeft}                                        from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}                                    from "@fortawesome/react-fontawesome";
import {SlideCarousel}                                      from "@Xpresso/routes/common/components/slide-carousel/slide-carousel";

import "./xpresslinks-mobile.scss";

export const XpresslinksMobile = ({data, isEditable, view, xpresslinksOptions, xpresslinksOptionsPreview, formData, encodedURL}) => cs(
    consumeContext("apis"),
    ["bubbleNoti", ({}, next) => BubbleNoti2({next})],
    ["saving", ({}, next) => UseState({
        initValue: false,
        next,
    })],
    ["showError", ({}, next) => UseState({
        initValue: false,
        next,
    })],
    ["includeAddressFields", ({}, next) => next(data?.value?.address?.length < 1 || !data?.value?.address)],
    ({apis, bubbleNoti, saving, showError, includeAddressFields}) => (
        <div className="xpresslinks-mobile xpresslinks-mobile-xlm1">

            {isEditable.value && <div className="edit-container">
                <div className="title" xd-qa-type="label" xd-qa-name="Xpress Links">Xpress Links</div>
                <br />
                <div className="description" xd-qa-type="text" xd-qa-name="description">
                    Your shared campaign is now active and ready to be shared
                    with your social network. To customize your campaign
                    webpage, simply complete the fields within the Edit screen
                    below, Preview your campaign and then Share with your
                    network
                </div>
                <br />
                <div className="shareable-link-container" onClick={() => copyToClipboard(`${window.location.origin}/xlinks/${encodedURL}`, bubbleNoti)}>
                    <div className="share-title" xd-qa-type="label" xd-qa-name="Shareable URL">
                        Shareable URL: (Click to copy)
                    </div>
                    <div className="share-link" xd-qa-type="text" xd-qa-name="Share Link">{`${window.location.origin}/xlinks/${encodedURL}`}</div>
                </div>
                <br />

                <div className="buttons-container">
                    {view.value === PAGE_VIEW.PREVIEW &&
                        <div className="single-button-container">
                            <div className="edit-button"
                                onClick={() => {
                                    getTextDefaults({xpresslinksOptions, xpresslinksOptionsPreview, data})
                                    view.onChange("EDIT")
                                }}
                                xd-qa-type="button"
                                xd-qa-name="Edit"
                            >
                                Edit
                            </div>
                        </div>
                    }
                    {view.value === PAGE_VIEW.EDIT &&
                        <div className="multi-button-container">
                            <div className="cancel-button"
                                onClick={() => {
                                    handleCancel(xpresslinksOptions.value, xpresslinksOptionsPreview.value)
                                    view.onChange("PREVIEW")
                                }}
                                xd-qa-type="button"
                                xd-qa-name="Cancel"
                            >
                                Cancel
                            </div>

                            <div className={cx("save-button", {disabled: equalDeep(xpresslinksOptions.value, xpresslinksOptionsPreview.value)})}
                                onClick={async () => {
                                    if(!equalDeep(xpresslinksOptions.value, xpresslinksOptionsPreview.value))
                                    {
                                        saving.onChange(true)
                                        !saving.value && await apis.next.myNeighborhood.saveXpresslinks(xpresslinksOptions.value)
                                        handleSave(xpresslinksOptions.value, xpresslinksOptionsPreview.value)
                                        view.onChange("PREVIEW")
                                        saving.onChange(false)
                                    }
                                }}
                                xd-qa-type="button"
                                xd-qa-name="Save"
                            >
                                {saving.value ? "Saving..." : "Save"}
                            </div>
                        </div>
                    }
                </div>
                <br />
                <hr />
            </div>}

            {data.value.companyDefault.showCompanyHeader && (
                data.value.scheme.banner ? (
                    <div className="banner-container" style={{backgroundColor: data.value.scheme.headerColor}} xd-qa-type="image" xd-qa-name="Header">
                        <div className="logo-container">
                            <img src={data.value.agent.logo ?? data.value.scheme.logo} xd-qa-type="image" xd-qa-name="Logo"/>
                        </div>
                        <div className="banner">
                            <img src={data.value.scheme.banner} xd-qa-type="image" xd-qa-name="Banner"/>
                        </div>
                    </div>
                ) : (
                    <div className="logo-container" style={{backgroundColor: data.value.scheme.menuBackgroundColor}}>
                        <img src={data.value.agent.logo ?? data.value.scheme.logo} xd-qa-type="image" xd-qa-name="Logo"/>
                    </div>
                )
            )}
            <div className="main-page-container">

                <div className="information-container">
                    <div className="information-card">
                        {view.value === PAGE_VIEW.EDIT && showButton({key: "headLineActive", xpresslinksOptions})}
                        {xpresslinksOptions.value.headLineActive && <div className={cx("title", {editing: view.value === PAGE_VIEW.EDIT})}>
                            {view.value === PAGE_VIEW.PREVIEW && <div className="headline-text" xd-qa-type="text" xd-qa-name="Headline Title">{xpresslinksOptions.value.headLine || data.value.companyDefault.companyDefaultHeadline || data.value.xlinksDefault.xlinksHeadline}</div>}
                            {view.value === PAGE_VIEW.EDIT && <input
                                maxLength={65}
                                className="headline-text editing"
                                value={xpresslinksOptions.value.headLine || data.value.companyDefault.companyDefaultHeadline || data.value.xlinksDefault.xlinksHeadline}
                                {...bindInput(scopedState(xpresslinksOptions, ["headLine"]))}
                                xd-qa-type="textbox"
                                xd-qa-name="Headline Title"
                            />}
                        </div>}
                        <br />
                            {view.value === PAGE_VIEW.PREVIEW && SlideCarousel({slides: getCarouselImages({images: data.value.images.small, xpresslinksOptions: xpresslinksOptions})})}
                            {view.value === PAGE_VIEW.EDIT && <div className="image-section editing">
                                {data.value.images.small.length > 1 && <div className="swap-images-container">
                                    <FontAwesomeIcon icon={faRightLeft} onClick={() => swapImages({key: "sidesReversed", xpresslinksOptions})}  xd-qa-type="button" xd-qa-name="Switch Images" />
                                </div>}
                                <div className={cx("images-container", {reverse: xpresslinksOptions.value.sidesReversed})}>
                                    <div className="image-block first">
                                        <div className="edit-image-container">
                                            {showButton({key: "showFront", xpresslinksOptions})}
                                            <div className="rotate-container">
                                                <i className="fa fa-solid fa-rotate-right" onClick={() => rotateRight({key: "rotateFront", xpresslinksOptions})} xd-qa-type="button" xd-qa-name="Front Rotate Right" />
                                                <i className="fa fa-solid fa-rotate-left" onClick={() => rotateLeft({key: "rotateFront", xpresslinksOptions})}  xd-qa-type="button" xd-qa-name="Front Rotate Left" />
                                            </div>
                                        </div>
                                        {<div className="image-container overlay">
                                            <img className={cx({
                                                overlay     : !xpresslinksOptions.value.showFront,
                                                "rotate-0"  : xpresslinksOptions.value.rotateFront === 0,
                                                "rotate-90" : xpresslinksOptions.value.rotateFront === 1,
                                                "rotate-180": xpresslinksOptions.value.rotateFront === 2,
                                                "rotate-270": xpresslinksOptions.value.rotateFront === 3
                                            })}
                                                src={data.value.images.small[0]}
                                                xd-qa-type="image"
                                                xd-qa-name="Front Image"
                                            />
                                        </div>}
                                    </div>
                                    <div className="image-block second">
                                        <div className="edit-image-container">
                                            {showButton({key: "showBack", xpresslinksOptions})}
                                            <div className="rotate-container">
                                                <i className="fa fa-solid fa-rotate-right" onClick={() => rotateRight({key: "rotateBack", xpresslinksOptions})}  xd-qa-type="button" xd-qa-name="Back Rotate Right" />
                                                <i className="fa fa-solid fa-rotate-left" onClick={() => rotateLeft({key: "rotateBack", xpresslinksOptions})}  xd-qa-type="button" xd-qa-name="Back Rotate Left" />
                                            </div>
                                        </div>
                                        {data.value.images.small.length > 1 && <div className="image-container">
                                            <img className={cx({
                                                overlay     : !xpresslinksOptions.value.showBack,
                                                "rotate-0"  : xpresslinksOptions.value.rotateBack === 0,
                                                "rotate-90" : xpresslinksOptions.value.rotateBack === 1,
                                                "rotate-180": xpresslinksOptions.value.rotateBack === 2,
                                                "rotate-270": xpresslinksOptions.value.rotateBack === 3
                                            })}
                                                src={data.value.images.small[1]}
                                                xd-qa-type="image"
                                                xd-qa-name="Back Image"
                                            />
                                        </div>}
                                    </div>
                                </div>
                            </div>}
                        <br />
                        {view.value === PAGE_VIEW.EDIT && showButton({key: "xlinksCommentsActive", xpresslinksOptions})}
                        {xpresslinksOptions.value.xlinksCommentsActive && <div className="information-text-container">
                            {view.value === PAGE_VIEW.PREVIEW && <div className="information-text" xd-qa-type="text" xd-qa-name="xlinksComment">{xpresslinksOptions.value.xlinksComments || data.value.companyDefault.companyDefaultDescription || data.value.xlinksDefault.xlinksDescription}</div>}
                            {view.value === PAGE_VIEW.EDIT && <textarea
                                className="information-text editing"
                                {...bindInput(scopedState(xpresslinksOptions, ["xlinksComments"]))}
                                xd-qa-type="textarea"
                                xd-qa-name="xlinksComment"
                            />}

                        </div>}
                    </div>
                </div>
                <br />

                <div className="contact-container">
                    <div className="contact-card">
                        {<div className="title" xd-qa-type="label" xd-qa-name="Contact">
                            Contact
                        </div>}
                        {view.value === PAGE_VIEW.EDIT && (data.value.agent.idAgent === "Branch Order" || data.value.agent.headshot) && showButton({key: "headShotsActive1", xpresslinksOptions})}
                        {xpresslinksOptions.value.headShotsActive1 && (data.value.agent.idAgent === "Branch Order" || data.value.agent.headshot) && <div className="agent-headshot-container">
                            <div className="agent-headshot">
                                {data.value.agent.idAgent === "Branch Order" ? (
                                    <FontAwesomeIcon className="icon1" icon={faBuilding}/>
                                ) : (
                                    <img src={data.value.agent.headshot} className="headshot-image" xd-qa-type="image" xd-qa-name="Headshot" />
                                )}
                            </div>
                        </div>}
                        <br />
                        <div className="agent-info-container">
                            <div className="line">
                                <div className="name" xd-qa-type="text" xd-qa-name="Line 1">{data.value.agent.line1}</div>
                            </div>
                            <br />
                            <div className="line">
                                <div className="line" xd-qa-type="text" xd-qa-name="Line 2">{data.value.agent.line2}</div>
                            </div>
                            <div className="line">
                                <div className="line" xd-qa-type="text" xd-qa-name="Line 3">{data.value.agent.line3}</div>
                            </div>
                            <div className="line">
                                <div className="line" xd-qa-type="text" xd-qa-name="Line 4">{data.value.agent.line4}</div>
                            </div>
                            <div className="line">
                                <div className="line" xd-qa-type="text" xd-qa-name="Line 5">{data.value.agent.line5}</div>
                            </div>
                            <div className="line">
                                <div className="line" xd-qa-type="text" xd-qa-name="Line 6">{data.value.agent.line6}</div>
                            </div>
                            <div className="line">
                                <div className="line" xd-qa-type="text" xd-qa-name="Line 7">{data.value.agent.line7}</div>
                            </div>
                            <div className="line">
                                <div className="line" xd-qa-type="text" xd-qa-name="Line 8">{data.value.agent.line8}</div>
                            </div>
                            <br />
                            <br /><br />
                        </div>
                        {view.value === PAGE_VIEW.EDIT && showButton({key: "contactInformationActive", xpresslinksOptions})}
                        {xpresslinksOptions.value.contactInformationActive && <div className="contact-text-container">
                            {view.value === PAGE_VIEW.PREVIEW && <div className="contact-text" xd-qa-type="text" xd-qa-name="Contact Information">{xpresslinksOptions.value.contactInformation || data.value.companyDefault.companyDefaultContactInformation || data.value.xlinksDefault.xlinksContact}</div>}
                            {view.value === PAGE_VIEW.EDIT && <textarea
                                className="contact-text editing"
                                {...bindInput(scopedState(xpresslinksOptions, ["contactInformation"]))}
                                xd-qa-type="textarea"
                                xd-qa-name="Contact Information"
                            />}
                        </div>}
                        <br /><br />

                        {contactFormContent({state: formData, showError, includeAddressFields, view})}

                        <div className="submit-button-container">
                            <div className={cx("submit-button", {disabled: !contactFormStateValidator({state: formData, includeAddressFields})})}
                                onClick={async () => {
                                    if(!saving.value && !contactFormStateValidator({state: formData, includeAddressFields}))
                                    {
                                        showError.onChange(true);
                                    }
                                    if(!saving.value && contactFormStateValidator({state: formData, includeAddressFields}))
                                    {
                                        saving.onChange(true);
                                        await apis.next.myNeighborhood.submitContactForm({
                                            ...formData.value,
                                            idCompany: xpresslinksOptions.value.idCompany,
                                            idOrder: xpresslinksOptions.value.idOrder,
                                            idMailingListAddress: data.value.idMailingListAddress,
                                            type: "xpresslinks"
                                        });
                                        formData.onChange({});
                                        bubbleNoti.addMessage({
                                            content: messageSubmissionSuccessful(data?.value?.agent?.name),
                                            duration: DURATION_NOTIFICATION.SHORT,
                                        });
                                        saving.onChange(false);
                                    }
                                }}
                                xd-qa-type="button"
                                xd-qa-name="Submit"
                            >Submit</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
);

const showButton = ({key, xpresslinksOptions}) => (
    <div className="xpresslinks-show-button xpresslinks-show-button-xsb123">
        <div className="button-container"
            onClick={() => {
                if(key === "showFront" || key === "showBack")
                    validateOneImageVisible(key, xpresslinksOptions)
                scnv(xpresslinksOptions, [key], () => !xpresslinksOptions.value[key])
            }}
            xd-qa-type="button"
            xd-qa-name={key + " Button"}
        >
            <div className="button-content">
                <div className="check-box">
                    {Checkbox({
                        checked: xpresslinksOptions.value[key],
                        rounded: true,
                        xdQaName: key
                    })}
                </div>
                <div className="text" xd-qa-type="label" xd-qa-name="Show">
                    Show
                </div>
            </div>
        </div>
    </div>
)

const validateOneImageVisible = (id, xpresslinksOptions) => {
    if(id === "showFront" && !xpresslinksOptions.value.showBack)
        scnv(xpresslinksOptions, ["showBack"], () => true)
    if(id === "showBack" && !xpresslinksOptions.value.showFront)
        scnv(xpresslinksOptions, ["showFront"], () => true)
}
const getCarouselImages = ({images, xpresslinksOptions}) => {
    let tmp = [];
    xpresslinksOptions.value.showFront && tmp.push(<div className="image-container">
                                                <img className={cx("image", {
                                                    "rotate-0": xpresslinksOptions.value.rotateFront === 0,
                                                    "rotate-90": xpresslinksOptions.value.rotateFront === 1,
                                                    "rotate-180": xpresslinksOptions.value.rotateFront === 2,
                                                    "rotate-270": xpresslinksOptions.value.rotateFront === 3
                                                })}
                                                    src={images[0]}
                                                    xd-qa-type="image"
                                                    xd-qa-name="Front Image"
                                                />
                                            </div>)
    xpresslinksOptions.value.showBack && images.length > 1 && tmp.push(<div className="image-container">
                                                <img className={cx("image", {
                                                    "rotate-0": xpresslinksOptions.value.rotateBack === 0,
                                                    "rotate-90": xpresslinksOptions.value.rotateBack === 1,
                                                    "rotate-180": xpresslinksOptions.value.rotateBack === 2,
                                                    "rotate-270": xpresslinksOptions.value.rotateBack === 3
                                                })}
                                                    src={images[1]}
                                                    xd-qa-type="image"
                                                    xd-qa-name="Back Image"
                                                />
                                            </div>)

    if (xpresslinksOptions.value.sidesReversed) {
        tmp.reverse();
    }

    return [...tmp];
}

const handleSave = (obj1, obj2) => {
    for (const key in obj1) {
        obj2[key] = obj1[key];
    }
}

const handleCancel = (obj1, obj2) => {
    for (const key in obj2) {
        obj1[key] = obj2[key];
    }
}
const copyToClipboard = async (textToCopy, bubbleNoti) => {
    try {
        await navigator.clipboard.writeText(textToCopy);
        bubbleNoti.addMessage({
            content: "Copied to clipboard",
            duration: 2000,
        })
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
};

const swapImages = ({key, xpresslinksOptions}) => {
    const current = xpresslinksOptions.value[key]
    scnv(xpresslinksOptions, [key], () => !current)
}

const rotateRight = ({key, xpresslinksOptions}) => {
    const currentRotation = xpresslinksOptions.value[key]
    const newRotation = (currentRotation + 1) % 4
    scnv(xpresslinksOptions, [key], () => newRotation)
}

const rotateLeft = ({key, xpresslinksOptions}) => {
    const currentRotation = xpresslinksOptions.value[key]
    const newRotation = (currentRotation - 1 + 4) % 4
    scnv(xpresslinksOptions, [key], () => newRotation)
}

const getTextDefaults = ({xpresslinksOptions, xpresslinksOptionsPreview, data}) => {
    if(xpresslinksOptions.value.headLine === "") {
        scnv(xpresslinksOptions, ["headLine"], () => data.value.companyDefault.companyDefaultHeadline || data.value.xlinksDefault.xlinksHeadline)
        scnv(xpresslinksOptionsPreview, ["headLine"], () => data.value.companyDefault.companyDefaultHeadline || data.value.xlinksDefault.xlinksHeadline)
    }
    if(xpresslinksOptions.value.xlinksComments === "") {
        scnv(xpresslinksOptions, ["xlinksComments"], () => data.value.companyDefault.companyDefaultDescription || data.value.xlinksDefault.xlinksDescription)
        scnv(xpresslinksOptionsPreview, ["xlinksComments"], () => data.value.companyDefault.companyDefaultDescription || data.value.xlinksDefault.xlinksDescription)
    }
    if(xpresslinksOptions.value.contactInformation === "") {
        scnv(xpresslinksOptions, ["contactInformation"], () => data.value.companyDefault.companyDefaultContactInformation || data.value.xlinksDefault.xlinksContact)
        scnv(xpresslinksOptionsPreview, ["contactInformation"], () => data.value.companyDefault.companyDefaultContactInformation || data.value.xlinksDefault.xlinksContact)
    }
}